module.exports = __webpack_public_path__ + "static/img/IMG_20170729_203503.743835a1.jpg";